const contentWithTocBlock = {
  $blocks: document.querySelectorAll('section.content_with_toc_block'),
  init() {
    if (this.$blocks.length) {
      this.processBlocks();
      this.setUpListeners();
    }
  },

  processBlocks() {
    this.$blocks.forEach($block => {
      if ($block.classList.contains('type_toc')) {
        this.setUpToc($block);
      }
    });
  },

  setUpListeners() {
    PubSub.subscribe('toc:offset', (ev, shouldOffset) => {
      console.log('Should offset?', shouldOffset);
      this.$blocks
        .forEach($block => {
          if ($block.classList.contains('type_toc')) {
            if (shouldOffset) {
              $block.classList.add('header_visible');
            } else {
              $block.classList.remove('header_visible');
            }
          }
        });
    });
  },

  setUpToc($block) {
    const $menuWrapper = $block.querySelector('nav.toc');
    const $contentWrapper = $block.querySelector('.col.right > .content_wrapper');
    const $contentToggler = $block.querySelector('.col.right > .cta');
    const menuEl = $menuWrapper.dataset.menuel;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const $currActiveMenuItem = $menuWrapper.querySelector('a.active');
        const $menuItem = $menuWrapper.querySelector('[data-tocid="'+entry.target.dataset.tocid+'"]');

        if (entry.isIntersecting && !$menuItem.classList.contains('active')) {
          $currActiveMenuItem.classList.remove('active');
          $menuItem.classList.add('active');
        }
      });
    }, {
      root: null,
      threshold: 1.0
    });
    let $headingsForMenu;

    if (menuEl === 'auto' || !menuEl) {
      // step down through all headings until we find ones that have more than 2 els
      for (let headLvl = 1; headLvl <= 6; headLvl++) {
        $headingsForMenu = $contentWrapper.querySelectorAll('h' + headLvl);

        if ($headingsForMenu.length >= 2 ) {
          console.log('Table of Contents found headings: ', $headingsForMenu);
          break;
        }
      }
    } else {
      $headingsForMenu = $contentWrapper.querySelectorAll(menuEl);
    }

    if ($headingsForMenu.length) {
      // generate the menu
      $headingsForMenu.forEach(($heading, index) => {
        const $menuItem = document.createElement('A');
        $menuItem.textContent = $heading.textContent;

        $heading.dataset.tocid = index;
        $menuItem.dataset.tocid = index;

        if (index === 0) {
          $menuItem.classList.add('active');
        }

        $menuItem.addEventListener('click', (ev) => {
          ev.preventDefault();

          $menuWrapper.querySelector('a.active').classList.remove('active');
          $menuItem.classList.add('active');

          if ($contentToggler && !$contentWrapper.classList.contains('active')) {
            $contentWrapper.classList.add('active');
            $contentToggler.classList.add('closed');
          }

          // push scrolling into view to the back of the queue
          // so the content has enough time to reveal
          setTimeout(() => {
            $heading.scrollIntoView();

            setTimeout(() => {
              PubSub.publish('header.hide');
            }, 30)
          }, 10);
        });

        $menuWrapper.append($menuItem);

        observer.observe($heading);
      });
    }

    if ($contentToggler) {
      $contentToggler.addEventListener('click', () => {
        $contentWrapper.classList.add('active');
        $contentToggler.classList.add('closed');
      });
    }
  }
};

contentWithTocBlock.init();
